<template>
    <section>
      <h1 class="text-2xl font-bold tracking-tight text-slate-900 mb-4">
        Trainer Statistics
      </h1>
      <div class="mt-2 container mx-auto px-2 py-1 sm:p-2 lg:p-4 bg-white rounded-lg">
        <div class="flow-root overflow-x-auto inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="min-w-full table-fixed divide-y divide-gray-300">
            <thead>
              <tr v-if="fields && fields.length">
                <!-- <th scope="col" class="relative px-7 sm:w-12 sm:px-6">
                  <input
                    type="checkbox"
                    class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                  />
                </th> -->
                <!-- <th
                  scope="col"
                  class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900"
                >
                  Name
                </th> -->
                <th
                  scope="col"
                  class="pr-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  v-for="d in fields"
                  :key="d"
                >
                  {{ d }}
                </th>
                <!-- <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-3">
                  <span class="sr-only">Edit</span>
                </th> -->
              </tr>
            </thead>
            <tbody
              class="divide-y divide-gray-200 bg-white"
              v-if="items && items.length"
            >
              <!-- Selected: "bg-gray-50" -->
              <tr v-for="d in items" :key="d.id">
                <!-- <td class="relative px-7 sm:w-12 sm:px-6">
                  Selected row marker, only show when row is selected.
                  <div class="absolute inset-y-0 left-0 w-0.5 bg-indigo-600"></div>

                  <input
                    type="checkbox"
                    class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                  />
                </td> -->
                <!-- Selected: "text-indigo-600", Not Selected: "text-gray-900" -->
                <td
                  class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-blue-700 hover:underline capitalize"
                >
                  <router-link
                    :to="{
                      name: 'AdminTrainersProfileAbout',
                      params: { id: d.user_id },
                    }"
                    target="_blank"
                  >
                    {{ d.trainer_name }}
                  </router-link>
                </td>
                <td
                  class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900 capitalize"
                >
                  {{ d.signup_email }}
                </td>
                <td
                  class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                >
                  {{ handleLastLogin(d.account_created_time) }}
                </td>
                <td
                  class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                >
                  {{ d.stripe_account_email || 'NA' }}
                </td>
                <td
                  class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                >
                  {{ d.stripe_user_id || 'NA' }}
                </td>
                <td
                  class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                >
                  {{ d.stripe_connected_time || "NA" }}
                </td>
                <td
                  class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                >
                  {{ (d.total_sales - d.total_platform_fee) || "NA" }}
                </td>
                <td
                  class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                >
                  {{ d.total_subscribed_users }}
                </td>
                <td
                  class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                >
                  {{ d.total_sessions_booked }}
                </td>
                <td
                  class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                >
                  {{ d.total_courses_booked }}
                </td>
              </tr>

              <!-- More people... -->
            </tbody>
          </table>
          <PaginationComponent
            v-if="items.length"
            :currentPage="current_page"
            :handlePageChange="handlePageChange"
            :totalPages="last_page"
          />
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { PaginationComponent } from "@/components/t-components";
  import Vue from 'vue';
  
  export default {
    name: "AdminTrainers",
    components: {
      PaginationComponent
    },
    data() {
      return {
        fields: [
          "Trainer Name",
          "Signup Email",
          "Account Created Date",
          "Stripe Email",
          "Stripe AccountId",
          "Stripe Connected Date",
          "Earnings (USD)",
          "Subscribers",
          "Booked Sessions",
          "Booked Courses"
        ],
        items: [],
        current_page: 1,
        last_page: 1
      };
    },
    methods: {
      async handlePageChange(page) {
        await this.handleGetAdminStats(page)
      },
      handleGetAdminStats (pageNo) {
        const query = {page: pageNo}
        this.$store.dispatch('getTrainerStatistics', query).then((res) => {
            res && res.data && res.data.length ? this.items = res && res.data : ''
            this.last_page = res.last_page
            this.current_page = res.current_page
        })
      }
    },
    created() {
      this.handleGetAdminStats(this.current_page)
    },
  };
  </script>